<template>
    <div class="component-wrapper">
        <div v-if="!resetToken" class="uk-section create-user-main">
            <alert v-show="submit_success" class="uk-alert-success"
                   :data="{title: 'Success!',
                       body: success_messageForm1,
                       closable:true}"></alert>
            <alert v-show="error" class="uk-alert-danger"
                   :data="{title: 'Oops. Something went wrong.',
                   body: error,
                   closable:true}"></alert>
            <div class="uk-container">
                <div class="uk-form-horizontal uk-margin-large uk-form-width-large uk-margin-auto">
                    <form-container v-show="!submit_success" form_title="Reset Password" :fieldList="resetPasswordForm1"
                                    @output="processForm1" @input="processInput"></form-container>
                </div>
            </div>
        </div>

        <div v-else-if="resetToken" class="uk-section create-user-main">
            <alert v-show="submit_success" class="uk-alert-success"
                   :data="{title: 'Success!',
                       body: success_messageForm2,
                       closable:true}"></alert>
            <alert v-show="error" class="uk-alert-danger"
                   :data="{title: 'Oops. Something went wrong.',
                   body: error,
                   closable:true}"></alert>
            <div class="uk-container">
                <div class="uk-form-horizontal uk-margin-large uk-form-width-large uk-margin-auto">
                    <form-container v-show="!submit_success" form_title="Reset Password" :fieldList="resetPasswordForm2"
                                    @output="processForm2" @input="processInput" :reset-signal="resetSignal"></form-container>
                </div>
                <button v-show="submit_success" class="uk-button uk-button-primary"><a href="/login/">Login with your new password!</a></button>
            </div>
        </div>
                              <spinner-overlay v-if="showOverlay"/>
    </div>
</template>

<script>
  import FloatFieldInput from "./theme/Input.vue"
  import formContainer from "./theme/formContainer.vue"
  import apiCall from '../store/apicall.js'
    import Alert from "./theme/Alert.vue"
    import SpinnerOverlay from "./theme/SpinnerOverlay.vue"

    export default {
        name: "createUser",
        		components: {
                    FloatFieldInput,
                    formContainer,
                    Alert,
                    SpinnerOverlay
                },
        data: function () {
            return {
                resetPasswordForm1: [['email'],],
                resetPasswordForm2: [['password'],['confirmPassword']],
                resetSignal: false,
                success_messageForm1: "We just sent you an email with a link. Click that link to finish updating your password",
                success_messageForm2: "Congrats! You have reset your password. Click the button below to login",
                submit_success: false,
                submitted: false,
                resetToken: false,
                error: false,
                showOverlay: false,
            }
        },
        methods: {
            processForm1: function (output) {
                // localStorage.access = null;
			    // localStorage.refresh = null;
                this.showOverlay=true;
                this.submitted = true;
                console.log(output);
                let _t = this
                apiCall.post('accounts/reset-password/', output).then(
                    function (response) {
                        _t.showOverlay=false;
                        console.log(response);
                        if (response.data.status == "OK") {
                            _t.submit_success = true

                        } else {
                            _t.error = response.data
                        }
                    }
                ).catch(function (error) {
                        _t.error = error
                    })
            },
            processForm2: function (output) {

                this.submitted = true;
                console.log(output);
                let submit_this = {};
                submit_this['password'] = output['password'];
                submit_this['token'] = this.resetToken;
                let _t = this
                apiCall.post('accounts/reset-password/confirm/', submit_this).then(
                    function (response) {
                        console.log(response);
                        if (response.data.status == "OK") {
                            _t.submit_success = true
                        } else {
                            _t.error = response.data
                        }
                    }
                ).catch(function (error) {
                        _t.error = error.response.data.password
                        _t.resetSignal = true
                    }).then(()=>{_t.resetSignal = false})
            },
            processInput: function (input) {
                console.log(input)
            },
        },
        mounted() {
            if(this.$route.query.token){
                this.resetToken = this.$route.query.token;
            }
        }
    }
</script>

<style lang="less" scoped>

    .uk-section-primary{
        padding-top:10px !important;
    }

    .uk-section-primary button{
        margin-top:10px;
    }

    .uk-card-body p{
        margin: 0px;
    }

    a{
        color:white;
    }



</style>
